import * as Sentry from '@sentry/react';

declare const __SENTRY_RELEASE__: string;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
  release: typeof __SENTRY_RELEASE__ !== 'undefined' ? __SENTRY_RELEASE__ : undefined,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

  // Performance monitoring - sample 10% of transactions in production
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

  // Session Replay - capture 10% of sessions normally, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
